import { QueryHookOptions, useQuery, gql } from '@apollo/client';

const GROUP_BY_SLUG_QUERY_FOR_BREADCRUMB = gql`
  query groupBySlug($slug: String!) {
    groupBySlug(slug: $slug) {
      name
    }
  }
`;

export type GroupForBreadcrumb = {
  name: string;
};

type Data = {
  groupBySlug: GroupForBreadcrumb;
};

type Vars = {
  slug?: string;
};

export const useGroupBySlugForBreadcrumb = (slug?: string, options?: QueryHookOptions<Data, Vars>) =>
  useQuery<Data, Vars>(GROUP_BY_SLUG_QUERY_FOR_BREADCRUMB, {
    skip: !slug,
    variables: { slug },
    ...options,
  });
